import React, { Component } from 'react';
import logo from './../assets/logo.png';
import axios from 'axios';
import { getSettings } from '../services/getSettings';
import { useNavigate, NavLink } from 'react-router-dom';
import { BiLoaderAlt } from 'react-icons/bi';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { api } from '../Settings';

function withParams(Component) {
  return (props) => <Component {...props} navigation={useNavigate()} />;
}

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      emailError: '',
      passwordError: '',
      apiError: '',
      isLoading: false,
      showPassword: false,
      clientName: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validate = this.validate.bind(this);
    this.togglePassword = this.togglePassword.bind(this);

    getSettings().then((data) => {
      console.log(data)
      this.setState({clientName: data.ipgbridge.client_name})
    })
  }

  
  async componentDidMount() {
    const settings = await getSettings();
    console.log(settings);
  }

  handleChange(event) {
    const target = event.target;
    const val = target.value ? target.value : '';
    const value = target.type === 'checkbox' ? target.checked : val;
    const name = target.name;
    this.setState({ [name]: value });
    this.setState({ apiError: '', passwordError: '', emailError: '' });
  }

  togglePassword(event) {
    let showPw = this.state.showPassword;
    showPw = !showPw;
    this.setState({ showPassword: showPw });
  }

  validate() {
    let emailError = '';
    let passwordError = '';
    let apiError = '';

    this.setState({ apiError: '' });

    const reg =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (!this.state.email) {
      emailError = 'Email Field is required ';
    } else if (reg.test(this.state.email) === false) {
      emailError = 'Email Field is Invalid ';
    }
    if (!this.state.password) {
      passwordError = 'Password field is required';
    }
    if (emailError || passwordError) {
      this.setState({ emailError, passwordError });
      return false;
    }
    return true;
  }

  handleSubmit(event) {
    if (this.validate()) {
      const { navigation } = this.props;
      const that = this;

      that.setState({ isLoading: true });

      /*   let response = {"success":true,"data":{"permission":[{"code":"MANAGE_PAYMENTS","text":"Payment Requests"},{"code":"MANAGE_PAYMENT_REQUEST","text":"Create Payment Request"},{"code":"MANAGE_SETTING","text":"Settings"},{"code":"MANAGE_USERS","text":"Users"}],"user":{"name":"Shyama","email":"shyama.hemachaya@ebeyonds.com","id":"d2d835b29122fc2eb8b1bdb9f20c4d75"},"token":{"token_type":"Bearer","expires_in":3600,"access_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3MzhiMzZkZDNlYTE0NTFmYmJkYjMzYzdkMWI5ODZlMyIsImp0aSI6IjdiYmFhNWE2NDI2MWVhMTc3OGY3YWY5NDRhZDgwMmE5NGVlODE2NzdkMDdhZTk1NzQ4NWEzZWQ4NmM1ZmU2MjIyZDMxOGQwMzY5YmQzZmY2IiwiaWF0IjoxNjg1MDcyMjM2LCJuYmYiOjE2ODUwNzIyMzYsImV4cCI6MTY4NTA3NTgzNiwic3ViIjoiZDJkODM1YjI5MTIyZmMyZWI4YjFiZGI5ZjIwYzRkNzUiLCJzY29wZXMiOltdfQ.wB18LyrvK7dVgJjAUqA30opUSnJKWE42o55IXltRBtrDGx9XPvTNCMi3BRXVt39CLdwJcgJacZ8eajvd26zvZdr0xKc1Q_p17BuPKHuFvTtlfos6QLLh-EnaUvEmKOEZBLVy3ccLQBQvZ8jtByfzxprpL3gD8MftOKVePlQTiqUL4iS4Ps0wvnHdqCyfFFXmYql_M7BQ92X2Yr34JBvCCG_PB_FaRACCpjfHgN1rtR0of-y1lGstPHl_fiWoVJtIWLZn5YFMAYXiSlfocS3N2dtvSQPU_iB0636Mwrv0l30SvQlJdSDs3jjbMm9lPxULHRR2aSfUE8mB3v0lLGC-brROlPpQOjQNyqWxC9nrnyPDpTCV0bwApSrHqcUy2WZrPj9dekDAvxaXotGh2sXPm72rQhn1ABYOJYapffKMkL_nMSZOjQ_UHhegcDfRkv4UH6MZk_LwUij_YU28aPtOZEdawvbdVnjiV-QUVM4ZrAO0DdSqT_woNWKh1JOvyRk02r4BOfrDYAUgzsksXUCMMGA_TTVXo7W6r3PHjyK_DCGEBZw3J-QeD6uLRYcO2lad8FM4Yeb-Cgds04pKc9kuDaqjDOEoLt2m_bjiG6ruH1IesKO0D69mh0mwP6fvpunsj-wIr09JWu7RZHplJ0eIg7dImKtJpBkOclkUmrwE-u0","refresh_token":"def50200631b020d49f3009bd83909569e2ede0e2979aa842ffc6a26721a7dc796083f9e4e26c6bea1b133d7d915035f79209c651e71ffb0fb4ca29aaa836dc1af4b12490a8aacb7eea61b7924a6ae2600457345cd3e83ce7c59e2d81c59d1d70b12fe595d4377c7032478bea1dd2f7c9c5654a1177c994c556b61ec42a9976c5fe1471832120e74a0311979ea8f16aa7a0c3eee32a2177001c6c1a427555bb6cf3cdc982d161c761a3fdfb444276e22e00b464f36865031d2b557e45cd19b1bd9363ff20bfe65cc7c96dcb2f7b4f06ad27d49e097dcb43570d727125ac3a744f7aa93f93aeeae2f92c37ebd61eb867c76fc7796deb58709885ad567f0b11926c51d73c791febbb2ff848e099a910daeb3a5094054159da77b97a6110d31a3acf00de409e227eaf82ebb611ff1eed5c43eaf37f755b8cbed5cf315e91252117dabfb6a31beb6c14a1a75e004180b1aaadebd955e82b3c29fd7b50b4437c0e15dab90072d03c68fe576d4f40f15d6ecda987f92d100d21c0b611a1b6b601524832bc32e30457be21a0efc6df105204cfb3b9777d487ec0c19ed9a7b2a012e5e9285"},"client":{"logo_path":"https://static.xpay.ebeyonds.com/ebeyonds-logo.png","name":"IPGBridge QR APP QA","timezone":"Asia/Colombo"}},"user_key":"05e913a81014daa1700fb5f4a2c874b4","dash_data":{"base_url":"https://xpay.qa.ebeyonds.com"}};
      let data = response;
       localStorage.setItem("_userData",  JSON.stringify(data));  */

      axios
        .post(api.adminLogin, {
          email: this.state.email,
          password: this.state.password,
        })
        .then(function (response) {
          let data = response.data;
          console.log(data);
          if (data.success && data.data) {
            localStorage.setItem('_userData', JSON.stringify(data));
            navigation('/');
            navigation(0);
          } else {
            that.setState({ apiError: data.message });
          }

          that.setState({ isLoading: false });
        })
        .catch(function (error) {
          that.setState({ isLoading: false });
          console.log(error);
        });
    }

    event.preventDefault();
  }

  render() {
    const { showPassword } = this.state;
    return (
      <>
        <div className="login-form flex flex-col mx-auto w-10/12 md:w-[430px]">
          <div className="w-full text-left text-base text-gray">
            <form method="POST" className="bg-white" onSubmit={this.handleSubmit}>
              <div className="text-center ">
                <img className="logo mx-auto mb-2" width="223" height="auto" src={logo} />
              </div>
              <div className="mb-8 text-center lg:text-center">
                <h1 className="text-2xl md:text-3xl font-normal text-heading">Welcome To <br/> {this.state.clientName} IPG bridge</h1>
                {/* <p>you can login with your email address and password.</p> */}
              </div>
              <div className="mb-2 md:mb-4">
                <label className="block text-gray-700  font-semibold mb-2" htmlFor="email">
                  Email address
                </label>
                <input
                  onChange={this.handleChange}
                  className="shadow appearance-none border border-secondary rounded w-full py-5 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  value={this.state.email || ''}
                  name="email"
                  type="email"
                  placeholder="yourname@company.com"
                ></input>
                <span className="text-red-500 text-xs italic">{this.state.emailError}</span>
              </div>
              <div className="mb-2 md:mb-4">
                <label className="block text-gray-700 font-semibold mb-2 " htmlFor="password">
                  Password
                </label>
                <div className="relative">
                  <input
                    onChange={this.handleChange}
                    className="shadow appearance-none border border-secondary  rounded w-full py-5 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    value={this.state.password || ''}
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="************"
                  ></input>
                  <div onClick={this.togglePassword}>
                    {showPassword ? (
                      <FiEyeOff className="absolute right-4 top-1/2 -translate-y-1/2 text-lg cursor-pointer" />
                    ) : (
                      <FiEye className="absolute right-4 top-1/2 -translate-y-1/2 text-lg cursor-pointer" />
                    )}
                  </div>
                </div>

                <span className="text-red-500 text-xs italic">{this.state.passwordError}</span>
              </div>
              {/* <div className="flex justify-between mt-3">
                        <label className="flex items-center">
                            <input className="mr-2" type="checkbox"></input>
                            <span>Remember me</span>
                        </label>
                        <NavLink to="/forget-password" 
                        className=' text-secondary hover:text-primary'>Forgot Password</NavLink>
                    </div> */}
              <div className="text-center">
                {!this.state.isLoading && (
                  <button
                    type="submit"
                    className="inline-block w-full mt-5 btn bg-primary shadow-md py-5 px-5 rounded-md text-white hover:shadow-lg hover:opacity-80"
                  >
                    Log in
                  </button>
                )}
                {this.state.isLoading && (
                  <button
                    type="button"
                    className="w-full mt-5 btn bg-primary py-5 px-5 rounded-md text-white shadow-lg opacity-80 flex items-center justify-center cursor-default"
                  >
                    <BiLoaderAlt className="animate-spin h-5 w-5 mr-2" /> Loading...
                  </button>
                )}

                <span className="text-red-500 text-sm italic mt-2 text-left block">{this.state.apiError}</span>
                <p className="mt-2 md:mt-4">
                  Forget your password ?{' '}
                  <NavLink to="/forget-password" className="font-semibold">
                    Reset here
                  </NavLink>
                </p>
                {/* <p className='mt-4'>Don’t have an account ? <NavLink to="/registration" 
                        className=' text-secondary hover:text-primary'>Register here</NavLink></p> */}
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default withParams(LoginForm);
